import { getSizedImageURL } from '../../core/images';
import { debounce } from '../../core/helpers';
import { updateWishlistButton } from '../../sections/product-page/selectVariant';

const addProductImageToStickyAddToCart = () => {
  // Make sure we can now select a size only if at least one of them is available
  const allSizes = document.querySelectorAll('[data-product-option-sizes] [data-product-option-size]');
  const disabledSizes = document.querySelectorAll('[data-product-option-sizes] [data-product-option-size].disabled');
  if (disabledSizes.length < allSizes.length) {
    document.querySelectorAll('[data-desktop-sticky-add-to-cart-sizes]').forEach(el => el.classList.add('active'));
  }

  // Update the thumbnail to the correct color
  const variantImages = document.querySelectorAll('[data-product-thumbs] [data-product-thumb]');
  if (variantImages.length) {
    const firstImg = variantImages[0].querySelector('img');
    if (firstImg) {
      let newImageSrc = firstImg.getAttribute('src');
      newImageSrc = getSizedImageURL(newImageSrc, '40x60_crop_center', true);
      document.querySelectorAll('[data-desktop-sticky-add-to-cart-image] img').forEach(img => {
        img.setAttribute('src', newImageSrc);
      });
    }
  }
};

const displayFitColorsStickyAddToCart = () => {
  // Remove 'active' from all color
  document.querySelectorAll('[data-product-option-color-desktop-sticky]').forEach(el => {
    el.classList.remove('active');
  });

  // Add 'active' to the first color
  const firstColor = document.querySelector('[data-desktop-sticky-add-to-cart-colors] [data-index="0"]');
  if (firstColor) firstColor.classList.add('active');

  // Add 'active' to colors matching the fit
  const selectedFitEl = document.querySelector('[data-desktop-sticky-add-to-cart-fit].active');
  const selected_fit = selectedFitEl ? selectedFitEl.getAttribute('data-fit-handle') : null;

  document.querySelectorAll(`[data-product-option-color-desktop-sticky][data-plus-color="${selected_fit === 'plus'}"]`).forEach(el => {
    el.classList.add('active');
  });
};

const displayFitSizesStickyAddToCart = () => {
  const selectedFitEl = document.querySelector('[data-desktop-sticky-add-to-cart-fit].active');
  const selected_fit = selectedFitEl ? selectedFitEl.getAttribute('data-fit-handle') : null;

  // Remove 'active' from all size parents
  document.querySelectorAll('[data-product-option-size-desktop-sticky]').forEach(el => {
    if (el.parentElement) el.parentElement.classList.remove('active');
  });

  // Add 'active' to the first size
  const firstSize = document.querySelector('[data-desktop-sticky-add-to-cart-sizes] [data-index="0"]');
  if (firstSize) firstSize.classList.add('active');

  // Add 'active' to sizes matching the fit
  document.querySelectorAll(`[data-product-option-size-desktop-sticky][data-plus-size="${selected_fit === 'plus'}"]`).forEach(el => {
    if (el.parentElement) el.parentElement.classList.add('active');
  });
};

const refreshSizesInStickyAddToCart = () => {
  // Get all sticky size options (skip the first placeholder)
  const stickySelect = document.querySelector('[data-desktop-sticky-add-to-cart-sizes] select');
  if (!stickySelect) return;

  const stickyOptions = stickySelect.querySelectorAll('[data-product-option-size-desktop-sticky]');

  // Remove 'active' from all sizes
  document.querySelectorAll('[data-product-option-size-desktop-sticky]').forEach(el => {
    el.classList.remove('active');
  });

  // Add 'active' to sizes matching the fit
  const selectedFitEl = document.querySelector('[data-desktop-sticky-add-to-cart-fit].active');
  const selected_fit = selectedFitEl ? selectedFitEl.getAttribute('data-fit-handle') : null;

  document.querySelectorAll(`[data-product-option-size-desktop-sticky][data-plus-size="${selected_fit === 'plus'}"]`).forEach(el => {
    el.classList.add('active');
  });

  stickyOptions.forEach((option, idx) => {
    if (idx === 0) return; // skip placeholder

    const sizeHandle = option.getAttribute('data-size-handle');
    const overviewOption = document.querySelector(`[data-product-option-sizes] [data-product-option-size][data-size-handle="${sizeHandle}"]`);

    if (overviewOption) {
      // if (
      //   (selected_fit === 'plus' && option.getAttribute('data-plus-size') !== 'true') ||
      //   (selected_fit !== 'plus' && option.getAttribute('data-plus-size') === 'true')
      // ) {
      //   option.classList.add('visually-hidden');
      //   return;
      // } else {
      //   option.classList.remove('visually-hidden');
      // }

      if (overviewOption.classList.contains('disabled')) {
        option.classList.add('disabled');
        option.setAttribute('aria-disabled', 'true');
        option.setAttribute('disabled', 'true');

        // Select the placeholder size if the current one is disabled
        if (stickySelect.selectedIndex === idx) {
          stickySelect.selectedIndex = 0;
        }
      } else {
        option.classList.remove('disabled');
        option.removeAttribute('aria-disabled');
        option.removeAttribute('disabled');
      }

      if (overviewOption.classList.contains('active')) {
        stickySelect.selectedIndex = idx;
      }
    } else {
      option.classList.add('disabled');
      option.setAttribute('aria-disabled', 'true');
      option.setAttribute('disabled', 'true');
    }
  });
};

const initColorDropdown = () => {
  const selectColorElement = document.querySelector('[data-desktop-sticky-add-to-cart-colors] select');
  if (!selectColorElement) {
    return;
  }

  // Find the active color in the product overview
  const activeProductOverviewColor = document.querySelector('[data-product-option-color].active');
  if (!activeProductOverviewColor) {
    return;
  }

  // Get the color handle from the active overview color
  const colorHandle = activeProductOverviewColor.getAttribute('data-color-handle');

  // Find the corresponding sticky color option in the select
  const stickyColorOption = selectColorElement.querySelector(`[data-product-option-color-desktop-sticky][data-color-handle="${colorHandle}"]`);
  if (stickyColorOption) {
    stickyColorOption.selected = true;
    // Optionally, trigger a change event if needed:
    selectColorElement.dispatchEvent(new Event('change', { bubbles: true }));
  }
};

const initAmountDropdown = () => {
  const selectAmountElement = document.querySelector('[data-desktop-sticky-add-to-cart-amounts] select');
  if (!selectAmountElement) {
    return;
  }

  document.querySelectorAll('[data-product-option-amount-desktop-sticky]').forEach(el => {
    el.classList.add('active');
  });

  const stickyAddToCart = document.querySelector('[data-desktop-sticky-add-to-cart]');
  // stickyAddToCart.removeAttribute('aria-disabled');
  // stickyAddToCart.removeAttribute('disabled');
  // stickyAddToCart.querySelector('[data-add-to-cart-text]').innerHTML = '<span data-add-to-cart-available aria-label="Add to cart">Add to cart</span>';
};

export default () => {
  $(document).on('click touchend', '[data-desktop-sticky-add-to-cart]', (e) => {
    if (window.theme.breakpoints.current === 'mobile' || window.theme.breakpoints.current === 'tablet') {
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    const addToCartButton = document.querySelector('.product-actions [data-add-to-cart]');
    if (addToCartButton) {
      addToCartButton.click();
    }
  });

  $(document).on('click touchend', '[data-desktop-sticky-add-to-cart-fit]', (e) => {
    const item = e.currentTarget;

    // Remove 'active' from all fit options
    document.querySelectorAll('[data-desktop-sticky-add-to-cart-fit]').forEach(el => el.classList.remove('active'));
    // Add 'active' to the clicked fit
    item.classList.add('active');

    // Get the selected fit handle
    const selectedFit = item.getAttribute('data-fit-handle');

    // Trigger click on the corresponding product overview fit
    const overviewFit = document.querySelector(`[data-product-overview] [data-fit-handle="${selectedFit}"]`);
    if (overviewFit) {
      overviewFit.click();
    }

    displayFitColorsStickyAddToCart();
    displayFitSizesStickyAddToCart();
  });

  // A fit has been selected from the product overview
  document.addEventListener('astr-pdp-fit-selected', () => {
    // console.log('[ASTR] astr-pdp-fit-selected', $('[data-product-option-fit].active').length);
    const activeProductOverviewFit = document.querySelector('[data-product-option-fit].active');
    if (!activeProductOverviewFit) {
      return;
    }

    const selectedFitHandleOverview = activeProductOverviewFit.getAttribute('data-fit-handle');
    const activeStickyFit = document.querySelector('[data-desktop-sticky-add-to-cart-fit].active');
    const selectedFitHandleSticky = activeStickyFit ? activeStickyFit.getAttribute('data-fit-handle') : null;

    // Prevent entering in a loop
    if (selectedFitHandleOverview === selectedFitHandleSticky) {
      return;
    }

    const stickyFitOption = document.querySelector(`[data-desktop-sticky-add-to-cart-fit][data-fit-handle="${selectedFitHandleOverview}"]`);
    if (stickyFitOption) {
      stickyFitOption.click();
    }
  });

  // A color has been selected from the product overview
  document.addEventListener('astr-pdp-color-selected', () => {
    // console.log('astr-pdp-color-selected event received', document.querySelector('[data-product-option-color].active'));

    const activeProductOverviewSwatch = document.querySelector('[data-product-option-color].active');
    if (!activeProductOverviewSwatch) {
      return;
    }

    const selectedColorHandle = activeProductOverviewSwatch.getAttribute('data-color-handle');
    const selectColorElement = document.querySelector('[data-desktop-sticky-add-to-cart-colors] select');
    const stickyColorOption = selectColorElement
      ? selectColorElement.querySelector(`[data-product-option-color-desktop-sticky][data-color-handle="${selectedColorHandle}"]`)
      : null;

    if (stickyColorOption && selectColorElement) {
      stickyColorOption.selected = true;
      selectColorElement.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      // select the 1st option if no sticky color option is found
      const firstStickyColorOption = selectColorElement ? selectColorElement.querySelector('[data-product-option-color-desktop-sticky]') : null;
      if (firstStickyColorOption) {
        firstStickyColorOption.selected = true;
        selectColorElement.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    // It's safe to get the enabled sizes from the product overview since they have been initialized already
    refreshSizesInStickyAddToCart();

    updateWishlistButton();
  });

  // A size has been selected from the product overview
  document.addEventListener('astr-pdp-size-selected', () => {
    // console.log('astr-pdp-size-selected event received', document.querySelector('[data-product-option-sizes] li.active'));

    const activeProductOverviewSize = document.querySelector('[data-product-option-sizes] li.active');
    if (!activeProductOverviewSize) {
      return;
    }

    const sizeOption = activeProductOverviewSize.querySelector('[data-product-option-size]');
    const selectedSizeHandle = sizeOption ? sizeOption.getAttribute('data-size-handle') : null;

    if (selectedSizeHandle) {
      const stickySelect = document.querySelector('[data-desktop-sticky-add-to-cart-sizes] select');
      const stickySizeOption = stickySelect
        ? stickySelect.querySelector(`[data-product-option-size-desktop-sticky][data-size-handle="${selectedSizeHandle}"]`)
        : null;
      
      if (stickySelect && stickySizeOption) {
        stickySizeOption.selected = true;
        stickySelect.dispatchEvent(new Event('change', { bubbles: true }));

      }
    }
  });

  // An amount (gift card) has been selected from the product overview
  document.addEventListener('astr-pdp-amount-selected', () => {
    // console.log('astr-pdp-amount-selected event received');
    const selectAmountElement = document.querySelector('[data-desktop-sticky-add-to-cart-amounts] select');
    if (!selectAmountElement) {
      return;
    }

    // Sync the selected value from the overview to the sticky select
    const overviewAmountSelect = document.querySelector('[data-option-amount] select');
    if (overviewAmountSelect) {
      const selectedValue = overviewAmountSelect.value;
      for (let i = 0; i < selectAmountElement.options.length; i++) {
        if (selectAmountElement.options[i].value === selectedValue) {
          selectAmountElement.selectedIndex = i;
          break;
        }
      }
    }
  });

  document.querySelectorAll('[data-desktop-sticky-add-to-cart-main] select').forEach(select => {
    select.addEventListener('change', (e) => {
      const el = e.target;

      // Handle color select
      if (el.classList.contains('sticky-add-to-cart__colors-list')) {
        const selectedOption = el.options[el.selectedIndex];
        const colorHandle = selectedOption.getAttribute('data-color-handle');
        const stickyAddToCart = document.querySelector('[data-desktop-sticky-add-to-cart]');

        // Sync product overview color
        const overviewColor = document.querySelector(`[data-product-option-color][data-color-handle="${colorHandle}"]`);
        if (overviewColor && !overviewColor.classList.contains('active')) {
          overviewColor.click();
        }

        window.setTimeout(() => {
          addProductImageToStickyAddToCart();
          updateWishlistButton();
          refreshSizesInStickyAddToCart();

          // Find out if a size is selected and update the sticky add to cart accordingly
          const stickySelect = document.querySelector('[data-desktop-sticky-add-to-cart-sizes] select');
          if (stickySelect) {
            const selectedSizeOption = stickySelect.options[stickySelect.selectedIndex];
            if (selectedSizeOption && selectedSizeOption.getAttribute('data-size-handle')) {
              // stickyAddToCart.removeAttribute('aria-disabled');
              // stickyAddToCart.removeAttribute('disabled');
              stickyAddToCart.querySelector('[data-add-to-cart-text]').innerHTML = '<span data-add-to-cart-available="" aria-label="Add to cart">Add to cart</span>';
            }
            // } else {
            //   // stickyAddToCart.setAttribute('aria-disabled', 'true');
            //   // stickyAddToCart.setAttribute('disabled', 'disabled');
            //   stickyAddToCart.querySelector('[data-add-to-cart-text]').innerHTML = `<span data-add-to-cart-available aria-label="${window.theme.strings.selectSize}">${window.theme.strings.selectSize}</span>`;
            // }
          }
        }, 250);
      }

      // Handle size select
      if (el.classList.contains('sticky-add-to-cart__sizes-list')) {
        const selectedOption = el.options[el.selectedIndex];
        const sizeHandle = selectedOption.getAttribute('data-size-handle');
        const stickyAddToCart = document.querySelector('[data-desktop-sticky-add-to-cart]');
        // stickyAddToCart.removeAttribute('aria-disabled');
        // stickyAddToCart.removeAttribute('disabled');
        stickyAddToCart.querySelector('[data-add-to-cart-text]').innerHTML = '<span data-add-to-cart-available="" aria-label="Add to cart">Add to cart</span>';

        // Sync product overview size
        const overviewSize = document.querySelector(`[data-product-option-size][data-size-handle="${sizeHandle}"]`);
        if (overviewSize && !overviewSize.closest('li').classList.contains('active')) {
          overviewSize.click();
        }
      }

      // Handle amount select
      if (el.classList.contains('sticky-add-to-cart__amounts-list')) {
        const selectedOption = el.options[el.selectedIndex];
        const amountValue = selectedOption.value;

        // Sync product overview amount
        const overviewAmountSelect = document.querySelector('[data-option-amount] select');
        if (overviewAmountSelect) {
          // Find the matching option in the overview select
          for (let i = 0; i < overviewAmountSelect.options.length; i++) {
            if (overviewAmountSelect.options[i].value === amountValue) {
              overviewAmountSelect.selectedIndex = i;
              overviewAmountSelect.dispatchEvent(new Event('change', { bubbles: true }));
              break;
            }
          }
        }
      }
    });
  });

  initColorDropdown();
  initAmountDropdown();

  // Sticky functionality
  window.addEventListener('scroll', debounce(() => {
    const $satc = $('[data-desktop-sticky-add-to-cart-main]');

    if (!$satc.length) {
      return;
    }

    if (window.innerWidth < 769) {
      $satc.removeClass('sticky');
      $satc.attr('aria-hidden', true);
      return;
    }

    const window_top = $(window).scrollTop();
    const $add_to_cart = $('.product-actions [data-add-to-cart]');
    const header_top = Number($('[data-header]').parent().css('top').replace('px', ''));

    let sticky_top = $('[data-main-nav]').outerHeight(true);
    if (header_top === 0) {
      sticky_top += $('[data-header]').outerHeight(true);
    } else if (header_top > 0) {
      sticky_top += $('[data-header]').outerHeight(true) + header_top;
    }

    if ($('body').hasClass('has-sticky-countdown-banner') || $('body').hasClass('has-sticky-promo-banner')) {
      sticky_top += $('[data-countdown-banner]').outerHeight(true);
    }

    $satc.css({ top: `${sticky_top}px` });

    const previously_sticky = $satc.hasClass('sticky');
    const needsclick_widget = document.querySelector('.needsclick');

    if (window_top > $add_to_cart.offset().top) {
      $satc.addClass('sticky');
      $satc.attr('aria-hidden', false);

      if (needsclick_widget) {
        needsclick_widget.style.display = 'none';
        needsclick_widget.setAttribute('aria-hidden', true);
        needsclick_widget.setAttribute('tabindex', '-1');
      }
    }
    else {
      $satc.removeClass('sticky');
      $satc.attr('aria-hidden', true);

      if (needsclick_widget) {
        needsclick_widget.style.display = 'block';
        needsclick_widget.setAttribute('aria-hidden', false);
        needsclick_widget.setAttribute('tabindex', '0');
      }
    }

    if ($satc.hasClass('sticky') && !previously_sticky) {
      addProductImageToStickyAddToCart();
    }

    // We want to re-adjust since a lot of things are now sticky and get their position re-calculated
    window.setTimeout(() => {
      $(window).trigger('scroll');
    }, 100);
  }, 1));
};
